export default __webpack_public_path__ + "static/media/emptyStateTickets.42780051.svg";